export const Propertyname = (Data) => {
    if (Data?.property_name && Data?.plan_properties[0].property_name) {
        return Data?.plan_properties[0].property_name + " - " + Data?.property_name;
    } else {
        return "RedBuyers Property " + Data?.id;
    }
}